// URL search params for /tasks: which tab, and optionally which task to select (deep links from
// a card's task block, a brief or a reminder).
import type { TaskListView } from "@shared/api";

export type TasksTab = Exclude<TaskListView, "open"> | "replies";

export const TASKS_TABS: readonly TasksTab[] = [
  "today",
  "upcoming",
  "waiting",
  "snoozed",
  "done",
  "replies",
];

export const TASKS_TAB_LABEL: Record<TasksTab, string> = {
  today: "Today",
  upcoming: "Upcoming",
  waiting: "Waiting on",
  snoozed: "Snoozed",
  done: "Done",
  replies: "Waiting for a reply",
};

export interface TasksSearch {
  view?: TasksTab | undefined;
  task?: string | undefined;
}

export function parseTasksSearch(raw: Record<string, unknown>): TasksSearch {
  const out: TasksSearch = {};
  const view = raw.view;
  if (
    typeof view === "string" &&
    (TASKS_TABS as readonly string[]).includes(view) &&
    view !== "today"
  )
    out.view = view as TasksTab;
  if (typeof raw.task === "string" && raw.task.trim()) out.task = raw.task.trim().slice(0, 200);
  return out;
}

/** The search that shows `view` (today is the default and stays out of the URL). */
export function tasksSearchFor(view: TaskListView | TasksTab | null, task?: string): TasksSearch {
  const tab = view && view !== "open" && view !== "today" ? view : undefined;
  return { ...(tab ? { view: tab } : {}), ...(task ? { task } : {}) };
}
